import { memo, useContext } from "react";
import { formatDateString } from "../../utils";
import { AppConfigContext } from "./AppConfigContext";

export const TimeRenderer = memo<{ value: string, dateFormat?: string, timeZone?: string }>(({ value, dateFormat, timeZone }) => {
  const appConfig = useContext(AppConfigContext);

  return (
    <>
      {formatDateString(value, dateFormat || appConfig?.timeFormatMoment, timeZone || appConfig?.timeZone, appConfig.serverTimeZone, appConfig.serverDateTimeFormatMoment)}
    </>
  );
});

export default TimeRenderer;

